import CompletedCard from './CompletedCard'

export default CompletedCard
